import { generateName } from "@common/Common";

export class ReportBuilderViewModel
{
    opened: boolean = false;
    reportName: string | null = null; 
    reportNameError: string | null = null;

    show()
    {
        this.reportName = generateName("Report");
        this.reportNameError = null;

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.reportName = null;
        this.reportNameError = null;
    }
}